import {
    FORMEDIT_SUBMIT_FORMSUBMIT_BEGIN,
    FORMEDIT_SUBMIT_FORMSUBMIT_SUCCESS,
    FORMEDIT_SUBMIT_FORMSUBMIT_FAILURE,
    FORMEDIT_SUBMIT_FORMSUBMIT_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitFormSubmit(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: FORMEDIT_SUBMIT_FORMSUBMIT_BEGIN,
      });
  
      let apiurl = '/api/b/formSubmit/add';
    
    if (params.id != undefined){
      apiurl = '/api/b/formSubmit/update';
    }

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: FORMEDIT_SUBMIT_FORMSUBMIT_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: FORMEDIT_SUBMIT_FORMSUBMIT_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitFormSubmitError() {
    return {
      type: FORMEDIT_SUBMIT_FORMSUBMIT_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case FORMEDIT_SUBMIT_FORMSUBMIT_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitFormSubmitPending: true,
          submitFormSubmitError: null,
        };
  
      case FORMEDIT_SUBMIT_FORMSUBMIT_SUCCESS:
        // The request is success
        return {
          ...state,
          submitFormSubmitPending: false,
          submitFormSubmitError: null,
        };
  
      case FORMEDIT_SUBMIT_FORMSUBMIT_FAILURE:
        // The request is failed
        return {
          ...state,
          submitFormSubmitPending: false,
          submitFormSubmitError: action.data.error,
        };
  
      case FORMEDIT_SUBMIT_FORMSUBMIT_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitFormSubmitError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/formedit/redux/submitFormSubmit.js